<style scoped>
    .transform-skewX-_45{
        transform: skewX(-45deg);
    }
    .transform-skewX-45{
        transform: skewX(45deg);
    }
    .mx-_4rem{
        margin-left: -.4rem;
        margin-right: -.4rem;
    }
    .bi-x-lg::before,.bi-check::before{
        font-weight: bold !important;
    }
    .border-start-transparent{
        border-left-color: transparent !important;
    }
    .border-bottom-transparent{
        border-bottom-color: transparent !important;
    }
    .top--_4rem{
        top: -.4rem;
    }
    .start--_15rem{
        left: -.15rem;
    }
    .camp-hover-scale.opacity-50:hover{
        scale: 1.1;
        z-index: 1;
        transition: scale .5s cubic-bezier(.25, 1.15, .35, 3.08);
        box-shadow: 0 0 .5rem #000;
    }
    .camp-hover-scale::after{
        content: '';
        position: absolute;
        top:0;
        bottom:0;
        left: 0;
        right: 0;
        background: linear-gradient(180deg,rgba(255,255,255,.3),transparent);
    }
    .btn-number-red{
        background:  linear-gradient(to top, rgba(0, 0, 0, .2), rgba(255, 255, 255, .2));
        box-shadow: .15rem .15rem 0 #bb1828, .15rem .15rem .1rem .02rem #000, inset 0 0 .3rem rgba(252, 252, 252, 0.6);
    }
    .btn-number-blue{
        background:  linear-gradient(to top, rgba(0, 0, 0, .2), rgba(255, 255, 255, .2));
        box-shadow: .15rem .15rem 0 #0b57c7, .15rem .15rem .1rem .02rem #000, inset 0 0 .3rem rgba(252, 252, 252, 0.6);
    }
    .btn-number-red[role='button']:hover,.btn-number-blue:hover{
        background:  linear-gradient(to top, rgba(0, 0, 0, .2), rgba(255, 255, 255, .2) 70%);
    }
    .btn-number-red[role='button']:active,.btn-number-blue:active{
        box-shadow: inset .1rem .1rem 0 #000, inset 0 0 .3rem rgba(252, 252, 252, 0.6);
    }
    .translate-0{
        transform: translate(0);
    }
    .hover-highlight:hover{
        background-image:  linear-gradient(to right, rgba(255, 255, 255, .1), rgba(255, 255, 255, .1));
    }
    .transition-transform{
        transition: transform .25s ease;
    }
    .translate-end{
        transform: translateX(-113%);
    }
</style>
<template>
    <div class="d-flex flex-column h-100">
        <!-- 横向导航 -->
        <navbar class="order-first d-flex flex-column d-sm-none" :has-chat-msg="hasChatMsg" :is-page-ready="isPageReady" :is-fullscreen="isFullscreen" ></navbar>
        <!-- 主体内容 -->
        <div class="d-flex flex-grow-1 h-0 flex-column position-xs-relative start-0 end-0 top-0 translate-0">
            <!-- 当前进程 -->
            <div class="d-flex fw-bold text-center small mx-_4rem text-nowrap">
                <div class="col d-flex flex-column position-relative me-1 text-light text-opacity-75">
                    <div class="position-absolute start-0 top-0 w-100 h-50 bg-success bg-opacity-50 transform-skewX-45"></div>
                    <div class="position-absolute start-0 bottom-0 w-100 h-50 bg-success bg-opacity-50 transform-skewX-_45 mb-_01rem"></div>
                    <span class="position-relative">闷盆</span>
                </div>
                <div class="col d-flex flex-column position-relative me-1 text-light text-opacity-75">
                    <div class="position-absolute start-0 top-0 w-100 h-50 bg-success bg-opacity-50 transform-skewX-45"></div>
                    <div class="position-absolute start-0 bottom-0 w-100 h-50 bg-success bg-opacity-50 transform-skewX-_45 mb-_01rem"></div>
                    <span class="position-absolute top-50 start-50 translate-middle">开盆</span>
                </div>
                <div class="col d-flex flex-column position-relative me-1 text-light text-opacity-75">
                    <div class="position-absolute start-0 top-0 w-100 h-50 bg-success bg-opacity-50 transform-skewX-45"></div>
                    <div class="position-absolute start-0 bottom-0 w-100 h-50 bg-success bg-opacity-50 transform-skewX-_45 mb-_01rem"></div>
                    <span class="position-absolute top-50 start-50 translate-middle">八扣</span>
                </div>
                <div class="col d-flex flex-column position-relative me-1 text-light text-opacity-75">
                    <div class="position-absolute start-0 top-0 w-100 h-50 bg-success bg-opacity-50 transform-skewX-45"></div>
                    <div class="position-absolute start-0 bottom-0 w-100 h-50 bg-success bg-opacity-50 transform-skewX-_45 mb-_01rem"></div>
                    <span class="position-absolute top-50 start-50 translate-middle">七扣</span>
                </div>
                <div class="col d-flex flex-column position-relative me-1 text-light text-opacity-75">
                    <div class="position-absolute start-0 top-0 w-100 h-50 bg-success bg-opacity-50 transform-skewX-45"></div>
                    <div class="position-absolute start-0 bottom-0 w-100 h-50 bg-success bg-opacity-50 transform-skewX-_45 mb-_01rem"></div>
                    <span class="position-absolute top-50 start-50 translate-middle">六扣</span>
                </div>
                <div class="col d-flex flex-column position-relative me-1 text-light text-opacity-75">
                    <div class="position-absolute start-0 top-0 w-100 h-50 bg-success bg-opacity-50 transform-skewX-45"></div>
                    <div class="position-absolute start-0 bottom-0 w-100 h-50 bg-success bg-opacity-50 transform-skewX-_45 mb-_01rem"></div>
                    <span class="position-absolute top-50 start-50 translate-middle">五扣</span>
                </div>
                <div class="col d-flex flex-column position-relative me-1 text-light">
                    <div class="position-absolute start-0 top-0 w-100 h-50 bg-success transform-skewX-45"></div>
                    <div class="position-absolute start-0 bottom-0 w-100 h-50 bg-success transform-skewX-_45 mb-_01rem"></div>
                    <span class="position-absolute top-50 start-50 translate-middle">四扣</span>
                </div>
                <div class="col d-flex flex-column position-relative text-light">
                    <div class="bg-secondary col transform-skewX-45"></div>
                    <div class="bg-secondary col transform-skewX-_45 mb-_01rem"></div>
                    <span class="position-absolute top-50 start-50 translate-middle">三扣</span>
                </div>
            </div>
            <!-- 视频 -->
            <div class="d-flex flex-column position-relative">
                <!-- 公告 -->
                <notice class="d-none d-sm-flex position-absolute"></notice>
                <!-- 视频 -->
                <div class="d-flex h-0 pt-60 position-relative flex-grow-1 pt-sm-0 index-1">
                    <media-video class="position-xs-absolute top-0 start-0 position-sm-relative" :video-list="videoList" :countdown="roomInfo.countdown" :room-class="['top-sm-0 mt-2 mt-sm-5 ms-1 ms-sm-2']" :time-class="['top-0 mt-2 mt-sm-5 ms-2']" :img-class="['h-100','w-100']"></media-video>
                </div>
            </div>
            <!-- 数据比较区 -->
            <div class="d-flex flex-column p-2 flex-grow-1 h-0 overflow-y-scroll scroll-none position-relative" style="background: linear-gradient(90deg,var(--bs-danger),var(--bs-primary));">
                <!-- 选手信息 -->
                <div class="d-flex mb-2">
                    <!-- 红方 -->
                    <div class="col d-flex justify-content-between align-items-center pe-3 rounded-pill me-2" style="box-shadow: 0 0 .3rem #000;">
                        <!-- 头像 -->
                        <div class="rounded-circle overflow-hidden border border-danger border-2 w-3rem h-3rem">
                            <img class="w-100 h-100" src="@/assets/images/home/red.jpg" alt="">
                        </div>
                        <!-- 基础信息 -->
                        <span class="fw-bold text-danger text-shadow-white">红方名称</span>
                    </div>
                    <!-- 蓝方 -->
                    <div class="col d-flex justify-content-between align-items-center ps-3 rounded-pill ms-2" style="box-shadow: 0 0 .3rem #000;">
                        <!-- 基础信息 -->
                        <span class="fw-bold text-primary text-shadow-white">蓝方名称</span>
                        <!-- 头像 -->
                        <div class="rounded-circle overflow-hidden border border-primary border-2 w-3rem h-3rem">
                            <img class="w-100 h-100" src="@/assets/images/home/blue.jpg" alt="">
                        </div>
                    </div>
                </div>
                <!-- 第n条数据 -->
                <div class="d-flex flex-column bg-black rounded px-2 pb-2 pt-1 mb-2">
                    <!-- 数据键值 -->
                    <div class="d-flex text-light fs-_8rem">
                        <span class="col">10000</span>
                        <span>票数</span>
                        <span class="col text-end">99</span>
                    </div>
                    <!-- 数据图形 -->
                    <div class="rounded overflow-hidden d-flex h-_5rem">
                        <span class="bg-danger progress-bar progress-bar-striped progress-bar-striped-right progress-bar-animated" :style="{width: (100/300*100)+'%'}"></span>
                        <span class="bg-primary progress-bar progress-bar-striped progress-bar-animated flex-grow-1"></span>
                    </div>
                </div>
                <!-- 第n条数据 -->
                <div class="d-flex flex-column bg-black rounded px-2 pb-2 pt-1 mb-2">
                    <!-- 数据键值 -->
                    <div class="d-flex text-light fs-_8rem">
                        <span class="col">2.35</span>
                        <span>重量(克)</span>
                        <span class="col text-end">2.22</span>
                    </div>
                    <!-- 数据图形 -->
                    <div class="rounded overflow-hidden d-flex h-_5rem">
                        <span class="bg-danger progress-bar progress-bar-striped progress-bar-striped-right progress-bar-animated" :style="{width: (2.35/(2.35+2.22)*100)+'%'}"></span>
                        <span class="bg-primary progress-bar progress-bar-striped progress-bar-animated flex-grow-1"></span>
                    </div>
                </div>
                <!-- 第n条数据 -->
                <div class="d-flex flex-column bg-black rounded px-2 pb-2 pt-1">
                    <!-- 数据键值 -->
                    <div class="d-flex text-light fs-_8rem">
                        <span class="col">2</span>
                        <span>场次</span>
                        <span class="col text-end">1</span>
                    </div>
                    <!-- 数据图形 -->
                    <div class="rounded overflow-hidden d-flex h-_5rem">
                        <span class="bg-danger progress-bar progress-bar-striped progress-bar-striped-right progress-bar-animated" :style="{width: (2.35/(2.35+2.22)*100)+'%'}"></span>
                        <span class="bg-primary progress-bar progress-bar-striped progress-bar-animated flex-grow-1"></span>
                    </div>
                </div>
            </div>
            <!-- 竞猜区 -->
            <div class="d-flex flex-column">
                <!-- 支持方选择 -->
                <div class="d-flex text-center ms--1_5rem me--1_5rem">
                    <div class="col bg-danger text-light fw-bold fs-5 skew-x--45 camp-hover-scale" :class="{'opacity-50':currCamp==2}" @click="currCamp=1">
                        <span class="d-block skew-x-45 py-2">支持红方</span>
                    </div>
                    <div class="col bg-primary text-light fw-bold fs-5 skew-x--45 camp-hover-scale" :class="{'opacity-50':currCamp==1}" @click="currCamp=2">
                        <span class="d-block skew-x-45 py-2">支持蓝方</span>
                    </div>
                </div>
                <!-- 步长选择 -->
                <!-- <div class="d-flex p-2 bg-danger mt--_1rem">
                    <div class="text-light">每次增加</div>
                    <div class="flex-grow-1 d-flex justify-content-evenly text-light text-center">
                        <div class="border border-warning rounded px-1 w-3rem position-relative">
                            <span class="text-warning">1</span>
                            <div class="position-absolute end-0 top-0 border border-start-transparent border-bottom-transparent border-warning border-5 w-0 h-0">
                                <i class="bi bi-check fs-_6rem text-success d-flex position-absolute top--_4rem start--_15rem"></i>
                            </div>
                        </div>
                        <span class="border rounded px-1 w-3rem">10</span>
                        <span class="border rounded px-1 w-3rem">100</span>
                        <span class="border rounded px-1">1000</span>
                        <span class="border rounded px-1">10000</span>
                        <span class="border rounded px-1">最大</span>
                    </div>
                </div> -->
                <!-- 数值选取区 -->
                <div class="d-flex justify-content-between p-1" :class="{'bg-danger':currCamp===1,'bg-primary':currCamp===2}">
                    <!-- 数值显示 -->
                    <div class="flex-grow-1 d-flex pe-1 py-1">
                        <div class="flex-grow-1 d-flex flex-column rounded overflow-hidden" :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}">
                            <div class="d-flex fs-_8rem">
                                <span class="px-1 bg-warning" style="background: linear-gradient(rgba(0,0,0,.2),rgba(255,255,255,.5),rgba(0,0,0,.2));">最高</span>
                                <span class="flex-grow-1 text-center text-light" style="background: linear-gradient(rgba(0,0,0,.2),rgba(255,255,255,.2),rgba(0,0,0,.2));">999999</span>
                            </div>
                            <div class="flex-grow-1 d-flex justify-content-center align-items-center fs-3">
                                <span class="fw-bold text-warning">{{ currTicket }}</span>
                            </div>
                            <div class="d-flex fs-_8rem">
                                <span class="px-1 bg-warning" style="background: linear-gradient(rgba(0,0,0,.2),rgba(255,255,255,.5),rgba(0,0,0,.2));">最低</span>
                                <span class="flex-grow-1 text-center text-light" style="background: linear-gradient(rgba(0,0,0,.2),rgba(255,255,255,.2),rgba(0,0,0,.2));">99</span>
                            </div>
                        </div>
                    </div>
                    <!-- 数字按钮 -->
                    <div class="d-flex text-light fw-bold fs-5">
                        <div class="d-flex flex-column">
                            <div class="d-flex">
                                <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(0)" role="button">0</div>
                                <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(1)" role="button">1</div>
                                <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(2)" role="button">2</div>
                                <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(3)" role="button">3</div>
                                <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(4)" role="button">4</div>
                                <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(-1)" role="button">⇦</div>
                            </div>
                            <div class="d-flex">
                                <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(5)" role="button">5</div>
                                <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(6)" role="button">6</div>
                                <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(7)" role="button">7</div>
                                <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(8)" role="button">8</div>
                                <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket(9)" role="button">9</div>
                                <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1" @click="setCurrTicket()" role="button">
                                    <i class="bi bi-trash d-flex"></i>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <div :class="{'btn-number-red':currCamp===1,'btn-number-blue':currCamp===2}" class="flex-grow-1 rounded w-2_5rem h-2_5rem d-flex align-items-center justify-content-center m-1 text-vertical" @click="setCurrTicket(Infinity)" role="button">最 大</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 竞猜单 -->
            <div class="d-flex flex-column text-light p-2 flex-grow-1 h-0 overflow-y-scroll scroll-none" style="background: #001a57;">
                <div class="fw-bold text-center mb-1">我的竞猜单</div>
                <div class="d-flex flex-column">
                    <!-- 第n阶段 -->
                    <div class="d-flex rounded overflow-hidden mb-2 border border-warning">
                        <div class="text-warning text-vertical text-center fw-bold">四扣</div>
                        <div class="d-flex flex-column flex-grow-1 text-center small">
                            <div class="d-flex text-warning bg-gradient">
                                <span class="col">支持方</span>
                                <span class="col">投票数</span>
                                <span class="col">有效票</span>
                            </div>
                            <div class="d-flex bg-primary bg-gradient">
                                <span class="col">蓝方</span>
                                <span class="col">99</span>
                                <span class="col">99</span>
                            </div>
                        </div>
                        <div class="bg-warning text-center d-flex flex-column justify-content-center lh-1 px-1 hover-highlight" @click="subTicket(-1)" style="box-shadow: inset 0 0 .2rem .1rem #8d7700;">
                            <span class="text-vertical1">点击</span>
                            <span class="text-vertical1">撤票</span>
                        </div>
                    </div>
                    <!-- 第n阶段 -->
                    <!-- <div class="d-flex rounded overflow-hidden mb-2 border border-secondary position-relative">
                        <div class="text-light text-vertical text-center fw-bold text-opacity-75">开盆</div>
                        <div class="d-flex flex-column flex-grow-1 text-center small">
                            <div class="d-flex text-light text-opacity-75 fw-bold bg-gradient">
                                <span class="col">支持方</span>
                                <span class="col">投票数</span>
                                <span class="col">有效票</span>
                            </div>
                            <div class="d-flex bg-danger bg-gradient bg-opacity-75 opacity-75">
                                <span class="col">红方</span>
                                <span class="col">1000</span>
                                <span class="col">100</span>
                            </div>
                            <div class="d-flex bg-primary bg-gradient bg-opacity-75 opacity-75">
                                <span class="col">蓝方</span>
                                <span class="col">99</span>
                                <span class="col">99</span>
                            </div>
                        </div>
                        <div class="position-absolute top-70 start-50 translate-middle border border-danger px-2 rounded-3 text-danger" style="rotate: 15deg;">
                            <i>已锁定</i>
                        </div>
                    </div> -->
                    <!-- 第n阶段 -->
                    <div class="d-flex rounded overflow-hidden mb-2 border border-secondary position-relative text-center small">
                        <div class="d-flex flex-column text-light bg-opacity-75 opacity-75">
                            <span class="col bg-gradient px-1 fw-bold">阶段</span>
                            <span class="col bg-success bg-gradient">开盆</span>
                            <span class="col bg-success bg-gradient">闷盆</span>
                        </div>
                        <div class="col d-flex flex-column bg-gradient bg-opacity-75 opacity-75">
                            <span class="col text-danger text-shadow-white fw-bold">红（投票数 / 有效票）</span>
                            <span class="col text-light bg-danger bg-gradient">10000 / 999</span>
                            <span class="col text-light bg-danger bg-gradient">10000 / 999</span>
                        </div>
                        <div class="col d-flex flex-column bg-gradient bg-opacity-75 opacity-75">
                            <span class="col text-primary text-shadow-white fw-bold">蓝（投票数 / 有效票）</span>
                            <span class="col text-light bg-primary bg-gradient">999 / 10</span>
                            <span class="col text-light bg-primary bg-gradient">999 / 10</span>
                        </div>
                        <!-- <div class="d-flex text-light bg-gradient bg-opacity-75 opacity-75">
                            <span class="col">阶段</span>
                            <span class="col">支持方</span>
                            <span class="col">投票数</span>
                            <span class="col">有效票</span>
                        </div>
                        <div class="d-flex bg-danger bg-gradient bg-opacity-75 opacity-75">
                            <span class="col">闷盆</span>
                            <span class="col">红方</span>
                            <span class="col">1000</span>
                            <span class="col">100</span>
                        </div> -->
                        <!-- <div class="position-absolute top-70 start-50 translate-middle border border-danger px-2 rounded-3 text-danger" style="rotate: 15deg;">
                            <i>已锁定</i>
                        </div> -->
                    </div>
                </div>
            </div>
            <!-- 按钮区 -->
            <div class="d-flex">
                <button class="btn btn-lg btn-success bg-gradient flex-grow-1" @click="subTicket(1)">投票</button>
                <!-- <button class="btn btn-lg btn-warning flex-grow-1 me-1">重置</button> -->
            </div>
            <!-- 弹幕区 -->
            <div class="position-fixed bottom-0 start-0 pointer-events text-light index-1 w-75 h-25 d-flex mb-5">
                <div class="position-relative index-1">
                    <span class="bg-dark bg-opacity-75 p-2 text-vertical hover-highlight pointer-events-all" @click="isShowMsg=!isShowMsg">{{isShowMsg?'隐藏弹幕':'显示弹幕'}}</span>
                </div>
                <div class="overflow-hidden d-flex flex-column-reverse align-items-start position-relative transition-transform" :class="{'translate-0':isShowMsg,'translate-end':!isShowMsg}">
                    <div class="d-flex align-items-start m-1 p-1 bg-dark bg-opacity-50 rounded-3">
                        <span class="bg-info rounded-pill small text-nowrap px-1 me-1">如果有名称</span>
                        <span class="flex-grow-1 lh-sm">过了这村可就没这店了，别人坐等分钱，你还在犹豫不决！</span>
                    </div>
                    <div class="d-flex align-items-start m-1 p-1 bg-dark bg-opacity-50 rounded-3">
                        <span class="bg-info rounded-pill small text-nowrap px-1 me-1">如果有名称</span>
                        <span class="flex-grow-1 lh-sm">买定离手5</span>
                    </div>
                    <div class="d-flex align-items-start m-1 p-1 bg-dark bg-opacity-50 rounded-3">
                        <span class="bg-info rounded-pill small text-nowrap px-1 me-1">如果有名称</span>
                        <span class="flex-grow-1 lh-sm">买定离手4</span>
                    </div>
                    <div class="d-flex align-items-start m-1 p-1 bg-dark bg-opacity-50 rounded-3">
                        <span class="bg-info rounded-pill small text-nowrap px-1 me-1">如果有名称</span>
                        <span class="flex-grow-1 lh-sm">买定离手3</span>
                    </div>
                    <div class="d-flex align-items-start m-1 p-1 bg-dark bg-opacity-50 rounded-3">
                        <span class="bg-info rounded-pill small text-nowrap px-1 me-1">如果有名称</span>
                        <span class="flex-grow-1 lh-sm">买定离手2</span>
                    </div>
                    <div class="d-flex align-items-start m-1 p-1 bg-dark bg-opacity-50 rounded-3">
                        <span class="bg-info rounded-pill small text-nowrap px-1 me-1">如果有名称</span>
                        <span class="flex-grow-1 lh-sm">买定离手1</span>
                    </div>
                </div>
            </div>
            <!-- 换台区 -->
            <change-room :room-list="roomList" :count-list="countList" :pearl-obj="pearlObj"></change-room>
        </div>
    </div>
</template>
<script>
import { COMMAND, LAYER_TYPE } from '@/assets/js/config';
import mediaVideo from "@/components/public/video.vue";
import navbar from '@/components/public/navbar.vue';
import notice from '@/components/public/notice.vue';
import changeRoom from '@/components/public/changeRoom.vue'
import { useLayer } from '@/assets/js/useLayer';
export default {
    components:{
        mediaVideo,
        notice,
        navbar,
        changeRoom,
    },
    props: {
        hasChatMsg:false,//是否有未读的客服消息
        isPageReady:false,//页面是否加载完毕
        isFullscreen:{
            type:Boolean,
            default:false
        },//当前是否全屏
    },
    data() {
        return {
            pearlObj: {
                id:0,//台面id
                pearl:[]//路单数据
            },//要重绘路单的对象
            countList:[],//路单统计列表
            videoList:[],//视频线路地址，当前支持最多两个
            currCamp:1,//1:红方，2:蓝方
            currTicket:0,//填写的票数
            ticketLimit:{
                min:0,
                max:0
            },//票数限制
            isShowMsg:true,//是否显示弹幕
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        roomInfo() {
            return this.$store.state.roomInfo;
        },
        roomList(){
            return this.$store.state.roomList;
        },
    },
    mounted() {
        this.setWsMessage();
    },
    unmounted() {
        // removeEventListener("resize",this.setResize);
        delete this.$root.wsMsgObj["guess"];
    },
    methods: {
        setWsMessage(){
            this.$root.wsMsgObj["guess"]=(data)=>{
                switch (data.command) {
                    case COMMAND.all_getvideo:
                        let videoArr=data.video;
                        let list=[];//拼装好的视频地址数组
                        for (let i = 0; i < videoArr.length; i++) {
                            list.push(data.flvline+'/'+videoArr[i]+'.flv');
                        }
                        this.videoList=list;
                        break;
                }
            }
        },
        /**
         * 设置当前票数
         */
        setCurrTicket(number){
            let max=this.userInfo.realCoin<this.ticketLimit.max?this.userInfo.realCoin:this.ticketLimit.max;
            if(number===undefined){//清空
                this.currTicket=0;
            }else if(number===-1){//删除最后一位
                this.currTicket=Math.floor(this.currTicket/10);
            }else if(number===Infinity){//最大(只能在金币和票数允许范围内)
                this.currTicket=max;
            }else{
                //添加数字
                let newTicket=this.currTicket*10+number;
                if(newTicket>max){
                    newTicket=max;
                }
                this.currTicket=newTicket;
            }

        },
        /**
         * 投票/撤票
         */
        subTicket(type){
            if(type==-1){//撤票
                if(true){//有投票
                    useLayer({str:"是否确认撤销当前阶段所有投票？",type:LAYER_TYPE.confirm,btn:[this.$t("common.yes"),this.$t("common.no")],yesFn:(i)=>{
                        layer.close(i);
                    }});
                }
            }else if(type==1){//投票
                
            }
        }
    },
}
</script>